module.exports = "/_next/static/images/9f5f591c0e5ca57f9e711ea2bbf14091-value-props.png";